import {
    URLAPI,
    TASK_PATH,
    TASK_LIST_PATH,
    TASK_LIST_CREATE_PATH,
    TASK_CREATE_PATH,
    TASK_LIST_UPDATE_PATH,
    TASK_UPDATE_PATH,
    TASK_TEMPLATE_DELETE_PATH,
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_task_list: {
        data: [],

        status: 0,
        message: {},
    },

    _create_task_list: {
        data: {},
        status: 0,
        message: {},
    },
    _create_task: {
        data: {},
        status: 0,
        message: {},
    },
    _update_task_list: {
        data: {},
        status: 0,
        message: {},
    },
    _update_task: {
        data: {},
        status: 0,
        message: {},
    },
    _delete_task_template: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_TASK_LIST = "GET_ALL_TASK_LIST";
export const CREATE_TASK_LIST = "CREATE_TASK_LIST";
export const CREATE_TASK = "CREATE_TASK";
export const UPDATE_TASK_LIST = "UPDATE_TASK_LIST";
export const UPDATE_TASK = "UPDATE_TASK";
export const DELETE_TASK_TEMPLATE = "DELETE_TASK_TEMPLATE";

export const task_list_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_TASK_LIST:
            return {
                ...state,
                _get_all_task_list: action.payload,
            };
        case CREATE_TASK_LIST:
            return {
                ...state,
                _create_task_list: action.payload,
            };
        case CREATE_TASK:
            return {
                ...state,
                _create_task: action.payload,
            };
        case UPDATE_TASK_LIST:
            return {
                ...state,
                _update_task_list: action.payload,
            };
        case UPDATE_TASK:
            return {
                ...state,
                _update_task: action.payload,
            };
        case DELETE_TASK_TEMPLATE:
            return {
                ...state,
                _delete_task_template: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllTaskList = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${TASK_LIST_PATH}`, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_TASK_LIST,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_TASK_LIST,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_TASK_LIST,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const searchTaskList = async (token, paramsUrl) => {
    return await axios.get(`${URLAPI}${TASK_LIST_PATH}${paramsUrl}`, {
        headers: {
            Authorization: `Basic ${token}`,
        },
    });
}

export const createTaskList = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${TASK_LIST_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_TASK_LIST,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_TASK_LIST,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_TASK_LIST,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const searchTask = async (token, paramsUrl) => {
    return await axios.get(`${URLAPI}${TASK_PATH}${paramsUrl}`, {
        headers: {
            Authorization: `Basic ${token}`,
        },
    });
}

export const createTask = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${TASK_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_TASK,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_TASK,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_TASK,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateTaskList = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${TASK_LIST_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_TASK_LIST,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_TASK_LIST,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_TASK_LIST,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateTask = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${TASK_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_TASK,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_TASK,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_TASK,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const deleteTaskTemplate = (token, id) => async (dispatch) => {
    try {
        const response = await axios.delete(
            `${URLAPI}${TASK_TEMPLATE_DELETE_PATH}${id}/`,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: DELETE_TASK_TEMPLATE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: DELETE_TASK_TEMPLATE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: DELETE_TASK_TEMPLATE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_task_list = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};


export const clear_task = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
